import React, { createContext, useState, useCallback, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState(() => {
        // Initialize from localStorage
        const token = localStorage.getItem('adminToken');
        const userJson = localStorage.getItem('adminUser');
        const user = userJson ? JSON.parse(userJson) : null;

        return {
            token,
            user,
            isLoggedIn: !!(token && user && user.role === 'admin')
        };
    });

    // Method to set auth after successful login
    const setAuthData = useCallback((token, user) => {
        localStorage.setItem('adminToken', token);
        localStorage.setItem('adminUser', JSON.stringify(user));
        setAuth({
            token,
            user,
            isLoggedIn: true
        });
    }, []);

    // Method to clear auth on logout or 401
    const setUnauthorized = useCallback(() => {
        console.log('🔓 setUnauthorized() called - clearing auth state');
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminUser');
        setAuth({
            token: null,
            user: null,
            isLoggedIn: false
        });
        console.log('✅ Auth state cleared');
    }, []);

    // Method to logout
    const logout = useCallback(() => {
        setUnauthorized();
    }, [setUnauthorized]);

    const value = {
        auth,
        setAuthData,
        setUnauthorized,
        logout
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};
